import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import TitleHeader from "./titleHeader";
import Step from "../Components/FormElements/step";
import img from "../Resources/img/image-user-3.jpg";
import useBeforeFirstRender from '../customHook/useBeforFirstRender';
import Quiz from "../Components/FormElements/quiz";
import { addAnswers } from "../Store/simulate/actions";

export default function AdditionalInfoPart2() {
  const client = useSelector(state => state.simulate.policy.client);
  const data = useSelector(state => state.quiz.additionalInfo2);
  const dataClient = client.datosCliente;
  const history = useHistory();
  const dispatch = useDispatch();
  const {handleSubmit, register, errors} = useForm();
  const [orders, setOrders] = useState(["2.1.", "2.2."]);
  
  const navigationPrev = () => {
    history.push('/simulaciones/info-complementaria-1');
  };

  const onSubmit = values => {
    dispatch(addAnswers(values));
    history.push('/simulaciones/verificacion');
  };

  useBeforeFirstRender(dataClient);
    
  return (
    <div className="container">
      <div className="additionalInfo">
        <div className="column">
          <Step handleClick={() => navigationPrev()} step="6" total="7"/>
          <TitleHeader 
            title="Información"
            titleBold="complementaria"
            subtitle="Necesitamos registrar estos datos"
          />
          <div className="column__form">
            <form className="questionsForm" onSubmit={handleSubmit(onSubmit)}>
              <Quiz 
                title="Prevención de lavado de activos y del financiamiento del terrorismo"
                register={register} 
                data={data} 
                errors={errors}
                orders={orders}
                setOrders={setOrders} />
              <button
                type="submit"
                className="questionsForm__button buttonCustom md">
                Continuar
              </button>
            </form>
          </div>
        </div>
        <div className="column-image">
          <img src={img}/>
        </div>
      </div>
    </div>
  );
}